<div class="checkbox-container">
    <div *ngFor="let option of options">
      <input
        type="checkbox"
        [id]="option"
        [value]="option"
        [checked]="selectedValues.includes(option)"
        (change)="onCheckboxChange($event)"
      />
      <label [for]="option">{{ option }}</label>
    </div>
  </div>
